import React from 'react';
import styled from 'styled-components';
import { TAnswerTest, TResponseTestsQuestions } from '../../../../../store/interactive/types';

interface Props {
  current?: number;
  questions: TResponseTestsQuestions[];
  myAnswers: TAnswerTest[] | null;
  onSelect: (idx: number) => void;
}

export const BlockNumbers: React.FC<Props> = React.memo(({ current, questions, myAnswers, onSelect }) => {
  return (
    <BlockNumS>
      {questions.map((quenstion, idx) => (
        <NumberS
          key={quenstion.id}
          onClick={() => onSelect(idx)}
          isDone={!!quenstion.answers.find((answer) => myAnswers?.find((myAnswer) => answer.id === myAnswer.answerId))?.is_correct}
          isActive={current === idx}
        >
          {idx + 1}
        </NumberS>
      ))}
    </BlockNumS>
  );
});

const BlockNumS = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 20px;
  margin-bottom: 20px;
  font-size: x-large;
`;

const NumberS = styled.div<{ isDone: boolean; isActive?: boolean }>`
  cursor: pointer;
  display: flex;
  padding: 5px;
  width: 41px;
  height: 41px;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 50%;
  }
  ${({ isDone }) => (isDone ? `color: #04c804;` : `color: red;`)}
  ${({ isActive }) =>
    isActive &&
    `
    border: 3px solid;
    border-radius: 20px;
  `}
`;
